import { useState } from "react";
import { Grid } from "@/components/shared/grid";
import { IconLabel } from "@/components/shared/icon-label";
import { ListHeading } from "@/components/shared/list-header";
import { useRoute } from "@/components/shared/router";
import { Image, View } from "@/components/ui";
import { useAuthState } from "@/store/auth";

import { sendAnalyticData } from "../../../../lib/monitoring/analytics";
import type { GiftCardGroup } from "../account-gift-card-history-component/lib";
import { getOccasionsByGroup } from "../account-gift-card-history-component/lib";
import { GiftCardGroupToggle } from "../gift-card-group-toggle";

export const GiftCardOccasion = () => {
  const { push } = useRoute();
  const [group, setGroup] = useState<GiftCardGroup>("moment");
  const accountType = useAuthState((state) => state.data.userInfo.accountType);

  const onClickOccasion = (key: string) => {
    sendAnalyticData({
      name: "initiate_gift_card",
      values: {
        account_type: accountType,
      },
    });
    push({ pageKey: "giftCardNew", query: { key } });
  };

  const occasions = getOccasionsByGroup(group);

  return (
    <View className="flex flex-col">
      <View className="px-4 py-3">
        <ListHeading title="Pick a gift card" />
      </View>
      <View className="px-4">
        <GiftCardGroupToggle value={group} onChange={setGroup} />
      </View>
      <View className="p-4">
        <Grid
          data={occasions}
          gap={12}
          columns={4}
          render={({ title, icon, key }) => (
            <IconLabel
              icon={
                <View className="bg-greyBlue-100 flex h-14 w-14 items-center justify-center rounded-lg">
                  <View className="h-10 w-10">
                    <Image src={icon} className="h-full w-full" />
                  </View>
                </View>
              }
              label={title}
              className="cursor-pointer"
              onClick={() => onClickOccasion(key)}
            />
          )}
        />
      </View>
    </View>
  );
};
